// The small print under a bag line: "2 × ₹1,999" when more than one piece,
// and the MRP struck through when the line sells below it.

const num = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

// { qty, price, mrp } (mrp null unless above price), or null when there's nothing to add.
export function lineUnit(item) {
  if (!item) return null;
  const qty = Math.abs(num(item.weight ?? item.qty) ?? 0);
  const price = num(item.salePrice ?? item.sunitprice);
  if (!(qty > 0) || !(price > 0)) return null;
  const listed = num(item.mrpPrice) || num(item.listPrice) || num(item.slistprice);
  const mrp = listed > price ? listed : null;
  if (qty === 1 && !mrp) return null;
  return { qty, price, mrp };
}

// "Blue · 6-7Y · TL-SH-204": the variant's colour and size, then its style code.
export function lineVariant(label, code) {
  return [label, String(code || "").trim()].filter(Boolean).join(" · ") || null;
}
